<template>
    <div class="d-flex justify-space-between align-center">
        <div class="stars d-flex gap-half">
            <span v-for="i in 5" :key="i" @click="!readOnly ? selectValue(i) : ''">
                <font-awesome-icon
                    :icon="[i <= value ? 'fas' : 'far', 'star']"
                    :class="[!readOnly ? 'pointer' : '', 'text-warning']"
                    size="lg"
                />
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StarRating',
    props: {
        value: {
            type: Number,
            default: 0,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        selectValue(selectedValue) {
            this.$emit('input', selectedValue);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../variables.scss';

.pointer {
    cursor: pointer;
}

.stars {
    @media (max-width: xs) {
        gap: 0;
    }

    > img {
        @media (max-width: xs) {
            width: 45px;
            height: 35px;
            object-fit: contain;
        }
    }
}
</style>